import { useEffect, useState } from "react";
import { ThumbsDown, ThumbsUp } from "lucide-react";
import { track } from "@/lib/analytics";
import {
  useRoundVote,
  type RoundTargetType,
  type RoundVote,
} from "@/lib/rounds";

export function VoteButton({
  citySlug,
  threadId,
  targetType,
  targetId,
  score,
  myVote,
}: {
  citySlug: string;
  threadId: string;
  targetType: RoundTargetType;
  targetId: string;
  score: number;
  myVote: RoundVote;
}) {
  const vote = useRoundVote(citySlug, threadId);
  const [currentScore, setCurrentScore] = useState(score);
  const [currentVote, setCurrentVote] = useState<RoundVote>(myVote);

  useEffect(() => setCurrentScore(score), [score]);
  useEffect(() => setCurrentVote(myVote), [myVote]);

  const cast = (next: Exclude<RoundVote, 0>) => {
    const value: RoundVote = currentVote === next ? 0 : next;
    vote.mutate(
      { targetType, targetId, vote: value },
      {
        onSuccess: (response) => {
          setCurrentScore(response.score);
          setCurrentVote(response.myVote);
          track("vote", {
            target_type: targetType,
            target_id: targetId,
            vote: value,
          });
        },
      },
    );
  };

  return (
    <div className="pb-rounds-vote">
      <button
        type="button"
        aria-pressed={currentVote === 1}
        disabled={vote.isPending}
        onClick={() => cast(1)}
      >
        <ThumbsUp size={13} aria-hidden="true" />
        Helpful <span>{Math.max(0, currentScore)}</span>
      </button>
      <button
        type="button"
        className="pb-rounds-vote__down"
        aria-label="Mark as not helpful"
        aria-pressed={currentVote === -1}
        disabled={vote.isPending}
        onClick={() => cast(-1)}
      >
        <ThumbsDown size={13} aria-hidden="true" />
      </button>
      {vote.isError ? <span role="alert">Vote not saved.</span> : null}
    </div>
  );
}
